<script setup lang="ts">
import { TypeFieldList } from '@/entities/Inventory/TypeField'
import { computed } from 'vue'
import { flatMap } from 'lodash'
import { useTranslate } from '@/shared/lib'
import { useTypesEdgesModel } from './../../model/model.ts'

defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
})

const { trs } = useTranslate()
const model = useTypesEdgesModel()

/** Шапка таблицы */
const headers = [
  { title: trs('itf.name_label'), key: 'name', sortable: false },
  { title: trs('itf.type_field'), key: 'type', sortable: false },
  { title: trs('itf.show_in_table'), key: 'is_table', sortable: false },
]

/** Вычисляем список типов полей */
const fieldsTypes = computed<{ title: string; value: string }[]>(() => {
  return flatMap(TypeFieldList, (group) =>
    group.children.map((child) => ({
      title: child.name,
      value: child.key,
    })),
  )
})
</script>

<template>
  <VDataTable
    v-if="model.item"
    :loading="isLoading"
    :headers
    :items="model.objectTypeData"
    items-per-page="1000"
    hide-default-footer
  >
    <template #item.name="{ item }">
      <VTextField class="py-1" :model-value="item.name" readonly hide-details />
    </template>

    <template #item.type="{ item }">
      <VSelect class="py-1" :items="fieldsTypes" :model-value="item.type" readonly hide-details />
    </template>

    <template #item.is_table="{ item }">
      <VCheckbox v-model="model.item.table_fields" :value="item.id" hide-details />
    </template>
  </VDataTable>
</template>
